import * as React from "react";

import { DashboardTopicKnowledgeTestModel } from "models/ApiModels";

import { TableRow, TableCell, Typography } from "@mui/material";

import MuiLink from "components/MuiExtras/MuiLink";

import { getTopicUrl } from "views/Timeline/Components/FeedHelpers";
import { TextPluralization } from "components/TextPluralization";
import { GlobalClassKeys } from "assets/jss/common-styles";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import MuiColor from "components/MuiExtras/Typography/MuiColor";

/////////////////////////////////////////////////////////////////////////////////////

export interface RenderTopicModelListEvents {
    onSelectTopic?: (topicId: string, name: string, thumbnailUrl: string) => void;
}

/////////////////////////////////////////////////////////////////////////////////////

interface IRenderTopicModelListProps extends RenderTopicModelListEvents {
    indexOffset: number;
    items: DashboardTopicKnowledgeTestModel[],
    detailCountText?: {
        singular: string;
        plural: string;
    };
    showDrillColumn?: boolean;
    onDrillDown?: (item: DashboardTopicKnowledgeTestModel) => void;
}

export const RenderTopicTestModelList: React.FC<IRenderTopicModelListProps> = (props) => {

    return (
        <>
            {
                props.items.map((v, index) => {

                    var url = getTopicUrl(v.topicId);

                    var rightValue = v.percent != null ? `${v.percent.toFixed(1)}%` : v.total != null ? v.total : null;

                    return (
                        <TableRow key={index} >
                            <TableCell style={{ width: 1 }} className={GlobalClassKeys.bold}>
                                {props.indexOffset + index + 1}
                            </TableCell>

                            <TableCell style={{ width: 1 }}>
                                <MuiLink href={url} target="_blank">
                                    <img src={v.thumbnailUrl} alt={v.name} width="48" height="48" />
                                </MuiLink>
                            </TableCell>

                            <TableCell>
                                {
                                    props.onSelectTopic
                                        ? <MuiLink color="secondary" href={null} onClick={
                                            () => {
                                                props.onSelectTopic(v.topicId, v.name, v.thumbnailUrl);
                                            }
                                            }>{v.name}</MuiLink>
                                        : <b>{v.name}</b>
                                }
                                {
                                    v.detailCount != null &&
                                    <div>
                                        <MuiMuted><small>
                                            <span>{v.detailCount} </span>
                                            {
                                                props.detailCountText != null &&
                                                <TextPluralization count={v.detailCount} {...props.detailCountText} />
                                            }
                                        </small></MuiMuted>
                                    </div>

                                }
                            </TableCell>

                            {
                                rightValue != null && props.showDrillColumn &&
                                <TableCell align="right">
                                    {
                                        props.onDrillDown
                                            ? <MuiLink color="secondary" onClick={() => props.onDrillDown(v)}>{rightValue.toLocaleString()}</MuiLink>
                                            : rightValue.toLocaleString()
                                    }
                                    <div>
                                        <span>
                                            <Typography component="span" variant="caption">(</Typography>
                                            <MuiColor variant="success"><Typography component="span" variant="caption"><b>{v.correct?.toLocaleString() ?? "0"}</b></Typography></MuiColor>
                                            <Typography component="span" variant="caption">/</Typography>
                                            <MuiColor variant="error"><Typography component="span" variant="caption"><b>{v.wrong?.toLocaleString() ?? "0"}</b></Typography></MuiColor>
                                            <Typography component="span" variant="caption">)</Typography>
                                        </span>
                                    </div>
                                </TableCell>
                            }
                        </TableRow>
                    );
                })
            }
        </>
    );
}

RenderTopicTestModelList.defaultProps = {
    showDrillColumn: true
}